import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LayerErrorChipProps {
  /** The API's own fixed text for the layer, which already names it ("Blocks could not be read."). */
  message: string
  testId?: string
  className?: string
}

/**
 * A calendar layer the API could not read, said in place of what it would
 * have drawn: an unread source must never pass for a quiet week.
 *
 * Shared by the property Calendar tab's layer chips and each row of the
 * portfolio calendar, so the same failure reads the same on both.
 */
export function LayerErrorChip({ message, testId, className }: LayerErrorChipProps) {
  return (
    <span
      role="status"
      data-testid={testId}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border border-danger/50 bg-danger/10 px-2.5 py-1 text-xs text-danger',
        className
      )}
    >
      <AlertTriangle className="h-3 w-3 shrink-0" aria-hidden="true" />
      {message}
    </span>
  )
}
